//DBTables
// import { DBBuilding } from "../../types/DBTables";
import { Button, Modal } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { get } from "../../../modules/server";
import Notify from "devextreme/ui/notify";
import HtmlEditor from "devextreme-react/html-editor";
import { logAndNotifyError, logErrorSilently } from "../../../modules/logger";
import { ConfirmDialogEvent } from "../../../events/ConfirmDialogEvent";

//interface IProps {}

const ConfirmDialog = () => {
  const [show, setShow] = useState(false);
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");
  const evtRef = useRef<ConfirmDialogEvent | null>(null);

  const handleCancel = () => {
    setShow(false);
    if (evtRef.current) evtRef.current.reply(false);
    evtRef.current = null;
  };

  const handleOk = () => {
    setShow(false);
    if (evtRef.current) evtRef.current.reply(true);
    evtRef.current = null;
  };

  useEffect(() => {
    PubSub.subscribe("ui/confirm", async (msg, e: ConfirmDialogEvent) => {
      setHeader(e.title);
      setBody(e.body);
      setShow(true);
      evtRef.current = e;
    });

    return () => {
      PubSub.unsubscribe("ui/confirm");
    };
  }, []);

  return (
    <>
      <Modal show={show} onHide={handleCancel} size="xl" centered={false} scrollable={true}>
        <Modal.Header closeButton>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HtmlEditor valueType="html" value={body} className="HtmlEditor" readOnly></HtmlEditor>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Stäng
          </Button>
          <Button variant="primary" onClick={handleOk}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmDialog;
